import { Paper, Typography, useTheme } from '@mui/material'
import { Task } from 'utils/__generated__/graphql'

type TooltipContentProps = {
  task: Task
  fontSize: string
  fontFamily: string
}

function TooltipContent({ task }: TooltipContentProps) {
  const theme = useTheme()

  return (
    <Paper variant="outlined" elevation={0} sx={{ p: 2 }}>
      <Typography variant="body1">
        <strong>{task.name}</strong>
      </Typography>
      <Typography sx={{ ...theme.typography.caption }}>
        <b>Start:</b> {task.start.toLocaleDateString()}
      </Typography>
      <Typography sx={{ ...theme.typography.caption }}>
        <b>End:</b> {task.end.toLocaleDateString()}
      </Typography>
      {task.notes && (
        <Typography sx={{ ...theme.typography.caption }}>
          <b>Notes:</b> {task.notes}
        </Typography>
      )}
    </Paper>
  )
}

export default TooltipContent
